import { cleanURL } from "../../../lib/utils";
import { useLocation } from "react-router-dom";
import { TLeftMenuProps, TMenuCustomCSSClasses } from "./types";

export const HorizontalMenu = ({
    optionList,
    customCSSClasses,
}: TLeftMenuProps) => {
    const { pathname } = useLocation();
    const clearedPathName = `/${cleanURL(pathname)}`;

    const defaultClickHandler = (
        e: React.MouseEvent<HTMLLIElement, MouseEvent>,
        customClickHandler?: () => void
    ) => {
        e.preventDefault();
        e.stopPropagation();
        if (customClickHandler) customClickHandler();
    };

    const currCSSClasses: TMenuCustomCSSClasses = {
        active: customCSSClasses?.active || "active",
        menuList: customCSSClasses?.menuList || "",
        menuItem: customCSSClasses?.menuItem || "",
    };

    return (
        <div className="row bg-dark ">
            <div className="col" style={{ overflow: "auto" }}>
                <ul
                    style={{
                        overflow: "auto",
                        width: "380px",
                        padding: 0,
                        margin: 0,
                    }}
                    className={` ${currCSSClasses.menuList}`}
                >
                    {optionList.map((l) => (
                        <li
                            key={"li-" + l.label}
                            className={`d-inline ${
                                customCSSClasses?.menuItem
                            } ${
                                clearedPathName === l.pathName
                                    ? currCSSClasses.active
                                    : ""
                            }`}
                            onClick={(e) => {
                                defaultClickHandler(e, l.clickHandler);
                            }}
                        >
                            <button className="btn btn-dark menu-item-text-color my-2">
                                <i className={l.iconClass + " me-3"} />
                                {l.label}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
